import "D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\core-js\\modules\\es.promise.js";
import "D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\core-js\\modules\\es.object.assign.js";
import "D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
// Vue
import Vue from 'vue';
import i18n from './i18n';
import App from './App';
// 核心插件
import d2Admin from '@/plugin/d2admin';
// store
import store from '@/store/index';
import '@/styles/index.scss';
// 菜单和路由设置
import router from './router';
import { menuHeader, menuAside } from '@/menu';
import { frameInRoutes } from '@/router/routes';
import to from "@/libs/awaitToJs";
import * as filters from './filters';
Vue.prototype.$awaitTo = to;
/*
* 全局过滤器
* */
Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});

// 判断当前用户是否有操作权限
Vue.prototype.$auth = function () {
  // let permission = ''
  // if (this.$route.meta && this.$route.meta.permission) {
  //   permission = this.$route.meta.permission
  // }
  // let res = store.state.cpscc.menus.find(item => {
  //   return item.n99EHName === permission
  // })
  // if (res) {
  //   return res.code === 2
  // }
  return true;
};
Vue.prototype.$getStaffName = function (id) {
  if (id) {
    var ids = id.split('/');
    var res = store.state.cpscc.staffsList.filter(function (item) {
      return ids.indexOf(item.id) !== -1;
    });
    if (res.length) {
      var names = res.map(function (item) {
        return item.name;
      });
      return names.join('/');
    }
  }
  return id;
};
Vue.prototype.$getFileName = function (url) {
  return url;
};

// 核心插件
Vue.use(d2Admin);
new Vue({
  router: router,
  store: store,
  i18n: i18n,
  render: function render(h) {
    return h(App);
  },
  created: function created() {
    // store.commit('d2admin/menu/asideSet', []);
    // this.$store.dispatch('cpscc/init')
    // 处理路由 得到每一级的路由设置
    // this.$store.commit('d2admin/page/init', frameInRoutes)
    // 设置顶栏菜单
    // this.$store.commit('d2admin/menu/headerSet', menuHeader)
    // 初始化菜单搜索功能
    // this.$store.commit('d2admin/search/init', menuHeader)
  },
  mounted: function mounted() {
    // 展示系统信息
    this.$store.commit('d2admin/releases/versionShow');
    // 用户登录后从数据库加载一系列的设置
    this.$store.dispatch('d2admin/account/load');
    // 获取并记录用户 UA
    this.$store.commit('d2admin/ua/get');
    // 初始化全屏监听
    this.$store.dispatch('d2admin/fullscreen/listen');
  } // watch: {
  //   // 检测路由变化切换侧边栏内容
  //   '$route.matched': {
  //     handler (matched) {
  //       if (matched.length > 0) {
  //         const _side = menuAside.filter(menu => menu.path === matched[0].path)
  //         this.$store.commit('d2admin/menu/asideSet', _side.length > 0 ? _side[0].children : [])
  //       }
  //     },
  //     immediate: true
  //   }
  // }
}).$mount('#app');